import styled from 'styled-components';

export const Label = styled.label`
  font-weight: 500;
  color: black;
  margin: 0 5px;
`;
